{
  "upload": {
    "choose": "Choisir un fichier",
    "inProgress": "Envoi en cours…",
    "hint": "{{limitValue}} Mo maximum par fichier.",
    "replace": "Remplacer"
  },
  "errors": {
    "type": "Ce format n'est pas accepté ici. Formats acceptés : {{accepted}}.",
    "tooLarge": "Ce fichier dépasse la taille maximale de {{limitValue}} Mo."
  },
  "cover": {
    "title": "Image de couverture",
    "hint": "Elle s'affiche dans le catalogue public. JPEG, PNG ou WebP.",
    "add": "Ajouter une couverture",
    "remove": "Retirer la couverture",
    "alt": "Couverture du cours"
  },
  "resource": {
    "download": "Télécharger",
    "pdf": "Document PDF",
    "image": "Image"
  },
  "files": {
    "title": "Mes fichiers",
    "empty": "Aucun fichier pour le moment.",
    "delete": "Supprimer",
    "size": "{{sizeValue}} Mo"
  }
}
